import packageJson from '../package.json';
const appInfo = {
  title: 'Tanyaegyetem',
  version: packageJson.version,
};
export default appInfo;
